import * as React from 'react';

type IconMarketProps = React.SVGProps<SVGSVGElement>;

export const IconMarket: React.FC<IconMarketProps> = (props) => (
	<svg width={31} height={28} viewBox="0 0 31 28" fill="none" xmlns="http://www.w3.org/2000/svg">
	<rect x="2.5" y="2.75" width="26" height="25" rx="2" fill="#EFF4F1"/>
	<path d="M1.33464 2.06893C1.42829 1.03877 2.29202 0.25 3.32643 0.25H5.5V8.8634C5.5 10.1815 4.43148 11.25 3.1134 11.25C1.71001 11.25 0.609549 10.045 0.736606 8.64733L1.33464 2.06893Z" fill="#8BA293"/>
	<path d="M10.5 0.25H15.5V8.75C15.5 10.1307 14.3807 11.25 13 11.25C11.6193 11.25 10.5 10.1307 10.5 8.75V0.25Z" fill="#8BA293"/>
	<path d="M20.5 0.25H25.5V8.75C25.5 10.1307 24.3807 11.25 23 11.25C21.6193 11.25 20.5 10.1307 20.5 8.75V0.25Z" fill="#8BA293"/>
	<path d="M5.5 0.25H10.5V8.75C10.5 10.1307 9.38071 11.25 8 11.25C6.61929 11.25 5.5 10.1307 5.5 8.75V0.25Z" fill="#FFA692"/>
	<path d="M15.5 0.25H20.5V8.75C20.5 10.1307 19.3807 11.25 18 11.25C16.6193 11.25 15.5 10.1307 15.5 8.75V0.25Z" fill="#FFA692"/>
	<path d="M25.5 0.25H27.6736C28.708 0.25 29.5717 1.03877 29.6654 2.06893L30.2634 8.64733C30.3905 10.045 29.29 11.25 27.8866 11.25C26.5685 11.25 25.5 10.1815 25.5 8.8634V0.25Z" fill="#FFA692"/>
	<path d="M9.5 16.75C9.5 15.6454 10.3954 14.75 11.5 14.75H19.5C20.6046 14.75 21.5 15.6454 21.5 16.75V27.75H9.5V16.75Z" fill="#8BA293"/>
	</svg>


);


